import type { FromInterface } from '../../common/types';
import type { Types } from '../types';
import _schedules from './schedules';


function division (data: unknown): Pick<Types.Serialized.Division, 'displayName' | 'start' | 'end'> | undefined {

  if (                          !data          || typeof data          !== 'object'
    || !('division' in data) || !data.division || typeof data.division !== 'object'
  ) return;

  const d = data.division;
  if (!('displayName' in d && typeof d.displayName == 'string')) return;
  if (!('start'       in d && typeof d.start       == 'string')) return;
  if (!('end'         in d && typeof d.end         == 'string')) return;

  return {
    displayName: d.displayName,
    start:       d.start,
    end:         d.end
  };
}

export default {
  division:  division,
  schedules: _schedules
} satisfies FromInterface;